import { render } from "./IntrusionAlarm.vue?vue&type=template&id=4470a24e&scoped=true"
import script from "./IntrusionAlarm.vue?vue&type=script&lang=js"
export * from "./IntrusionAlarm.vue?vue&type=script&lang=js"

import "./IntrusionAlarm.vue?vue&type=style&index=0&id=4470a24e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4470a24e"]])

export default __exports__